import './styles.css';
import { TinesExperience } from './TinesExperience';

const root = document.querySelector<HTMLElement>('#app');
const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');

if (!root || !canvas) throw new Error('TINES experience shell is incomplete.');

const experience = new TinesExperience(root, canvas);
void experience.start();

if (import.meta.hot) import.meta.hot.dispose(() => experience.dispose());
